export default __webpack_public_path__ + "static/media/shoppingCart-refresh.12dba5f0.svg";